__webpack_require__.p = "/current/";